import React from 'react';
import PropTypes from 'prop-types';
import Translate from '@prisjakt/ui-translate';
import shallowEqual from 'shallowequal';
import SentimentBadge from '../sentiment-badge';

import * as S from './styles';

const StoreBadgeList = React.memo(
  ({ badges }) => {
    if (!badges || !badges.length) {
      return null;
    }

    return (
      <div>
        <S.StoreBadgeListTitle>
          <Translate domain="product">store-badge.title</Translate>
        </S.StoreBadgeListTitle>
        {badges.map(badge => (
          <SentimentBadge
            badge={badge}
            key={badge.id}
            showNrOfReviewsAs="text"
          />
        ))}
      </div>
    );
  },
  ({ badges: prevBadges }, { badges: nextBadges }) => {
    if (!prevBadges && !nextBadges) {
      return true;
    }
    if (
      (!prevBadges && nextBadges) ||
      (prevBadges && !nextBadges) ||
      prevBadges.length !== nextBadges.length
    ) {
      return false;
    }
    return prevBadges.every((badge, i) => shallowEqual(badge, nextBadges[i]));
  }
);

StoreBadgeList.propTypes = {
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      sentiment: PropTypes.oneOf(['positive', 'negative']),
      nrOfPositiveReviews: PropTypes.number.isRequired,
      nrOfReviews: PropTypes.number.isRequired,
    })
  ),
};

StoreBadgeList.defaultProps = {
  badges: null,
};

export default StoreBadgeList;
